module.exports = __webpack_public_path__ + "img/logo-small.2b6867be.png";